import { caseTypeLabel, type CaseType } from "./deriveCaseType";

const PASSTHROUGH_PREFIXES = new Set(["G", "GC", "AS", "HM"]);

export interface PassthroughPrefixWorkflowWarningInput {
  selectedPrefix: string | null | undefined;
  caseType: CaseType;
}

export interface PassthroughPrefixWorkflowWarningDetails {
  shouldWarn: boolean;
  selectedPrefix: string | null;
  workflowLabel: string;
  caseType: CaseType;
}

export function getPassthroughPrefixWorkflowWarningDetails({
  selectedPrefix,
  caseType,
}: PassthroughPrefixWorkflowWarningInput): PassthroughPrefixWorkflowWarningDetails {
  const normalizedPrefix = selectedPrefix?.trim().toUpperCase() || null;

  return {
    shouldWarn:
      !!normalizedPrefix &&
      PASSTHROUGH_PREFIXES.has(normalizedPrefix) &&
      caseType !== "pass_through",
    selectedPrefix: normalizedPrefix,
    workflowLabel: caseTypeLabel(caseType),
    caseType,
  };
}
